// Product Options Component - Handles variant selection, measurements toggle, and accordions
const selectors = {
  sizeSwitcher: '.size-switcher',
  measurementsCm: '.product-measurements .cm',
  measurementsInch: '.product-measurements .inch',
  swatchHeader: '.product-view .product-options .swatch .header',
  variantItems: '.product-view .product-options .swatch .variant-items',
  variantLabel: '.product-view .product-options .swatch .swatch-element.square input + label',
  accordionHead: '.accordion_head',
  accordionBody: '.accordion_body',
};

function productOptions() {
  initSizeSwitcher();
  initVariantSelection();
  initAccordions();
}

function initSizeSwitcher() {
  // Handle size/measurements switcher (CM/Inch toggle)
  document.addEventListener('click', (event) => {
    if (event.target.matches(`${selectors.sizeSwitcher}, ${selectors.sizeSwitcher} *`)) {
      const cmElements = document.querySelectorAll(selectors.measurementsCm);
      const inchElements = document.querySelectorAll(selectors.measurementsInch);

      cmElements.forEach((element) => {
        element.style.display = element.style.display === 'none' ? '' : 'none';
      });

      inchElements.forEach((element) => {
        element.style.display = element.style.display === 'none' ? '' : 'none';
      });
    }
  });
}

function initVariantSelection() {
  // Handle swatch header toggle
  document.addEventListener('click', (event) => {
    if (event.target.matches(`${selectors.swatchHeader}, ${selectors.swatchHeader} *`)) {
      const swatchHeader = event.target.closest(selectors.swatchHeader);
      if (swatchHeader) {
        const variantItems = swatchHeader.parentElement.querySelector(selectors.variantItems);
        if (variantItems) {
          const isVisible = variantItems.style.display !== 'none';
          variantItems.style.display = isVisible ? 'none' : 'block';
        }
      }
    }
  });

  // Handle variant label selection
  document.addEventListener('click', (event) => {
    if (event.target.matches(`${selectors.variantLabel}, ${selectors.variantLabel} *`)) {
      const label = event.target.closest(selectors.variantLabel);
      if (label) {
        // Find the closest variant-items container and hide it
        let current = label;
        while (current && !current.matches(selectors.variantItems)) {
          current = current.parentElement;
        }
        if (current) {
          current.style.display = 'none';
        }
      }
    }
  });
}

function initAccordions() {
  // Handle accordion toggle functionality
  document.addEventListener('click', (event) => {
    if (event.target.matches(`${selectors.accordionHead}, ${selectors.accordionHead} *`)) {
      event.preventDefault();

      const accordionHead = event.target.closest(selectors.accordionHead);
      if (accordionHead) {
        // Toggle active class
        accordionHead.classList.toggle('active');

        // Find the next accordion body element
        const accordionBody = accordionHead.nextElementSibling;
        if (accordionBody && accordionBody.matches(selectors.accordionBody)) {
          // Slide toggle effect
          if (accordionBody.style.display === 'none' || !accordionBody.style.display) {
            accordionBody.style.display = 'block';
            accordionBody.style.height = '0px';
            accordionBody.style.overflow = 'hidden';
            accordionBody.style.transition = 'height 0.3s ease';

            // Force reflow
            accordionBody.offsetHeight;

            accordionBody.style.height = accordionBody.scrollHeight + 'px';

            // Clean up after animation
            setTimeout(() => {
              accordionBody.style.height = '';
              accordionBody.style.overflow = '';
              accordionBody.style.transition = '';
            }, 300);
          } else {
            accordionBody.style.height = accordionBody.scrollHeight + 'px';
            accordionBody.style.overflow = 'hidden';
            accordionBody.style.transition = 'height 0.3s ease';

            // Force reflow
            accordionBody.offsetHeight;

            accordionBody.style.height = '0px';

            setTimeout(() => {
              accordionBody.style.display = 'none';
              accordionBody.style.height = '';
              accordionBody.style.overflow = '';
              accordionBody.style.transition = '';
            }, 300);
          }
        }
      }
    }
  });
}

export default productOptions;
